export class GenPersonCountryEntity{
    id:number;
    personId:number;
    countryId:number;

    constructor(){}
}